import { axiosClient } from 'net/ajax'

export const registerOauth = ({ carrierId }) =>
    axiosClient.post(`/ups_oauth/${carrierId}/register`, {})

export const verifyOauth = ({ carrierId, code }) =>
    axiosClient.post(`/ups_oauth/${carrierId}/verify`, { code })
